import { render, staticRenderFns } from "./editor_form.vue?vue&type=template&id=aabf5e14"
import script from "./editor_form.vue?vue&type=script&lang=js"
export * from "./editor_form.vue?vue&type=script&lang=js"
import style0 from "./editor_form.vue?vue&type=style&index=0&id=aabf5e14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports